<template>
    <div>
        <van-popup v-model="show" position="bottom" @click-overlay="onCancel">
            <van-area :area-list="areaList" @confirm="onConfirm" @cancel="onCancel" />
        </van-popup>
    </div>
</template>
<script>
import areaList from '../../utils/area.js'
export default {
    props:[
        'showPicker',
        'tipText'
    ],
     data() {
        return {
        areaList:areaList,
        show:false
        };
    },
    created(){
        
    },
    watch:{
        showPicker:function(){
            this.show=this.showPicker
        }
    },
      methods: {
        onConfirm(value) {
            console.log(value[0].code)
            let adress;
            let areaArray = ["820000","810000","710000","540000","650000","630000","640000","460000","450000","620000","530000","520000","150000"];
            //澳门，香港,台湾,西藏,新疆,青海,宁夏,海南,广西,甘肃,云南,贵州,镍锰钴
            let indexValue = areaArray.indexOf(value[0].code);
            if(indexValue != "-1"){
                this.$toast(this.tipText);
                return;
            }
            
            if(value){
                adress = value[0].name + " " + value[1].name + ' ' + value[2].name 
            }
            this.$emit('showPopup',adress)

        },
        onCancel(){
        this.$emit('showPopup')
        },
         init () {
            // 初始化地址选择器
            this.areaList = areaList // 初始化选择器数据
            // 初始化复选框
        },
    },
}
</script>
